<app-review-detail-card
  [title]="'createShipment.reviewAndPay.cards.additionalServices' | translate"
  editHref="/service"
  testId="review-additional-services"
  [showEdit]="showEdit()"
  (editRequested)="editRequested.emit($event)"
>
  <div class="review-additional-services-summary__rows">
    <div class="review-additional-services-summary__row">
      <puro-typography
        component="span"
        variant="body2"
        class="review-additional-services-summary__label"
      >
        {{ 'createShipment.reviewAndPay.additionalServices.declaredValue' | translate }}
      </puro-typography>
      <puro-typography component="span" variant="body2">
        @if (view().declaredValue !== null) {
          {{ formatCurrencyAmount(view().declaredValue ?? 0) }}
        } @else {
          {{ 'createShipment.reviewAndPay.additionalServices.no' | translate }}
        }
      </puro-typography>
    </div>
    <div class="review-additional-services-summary__row">
      <puro-typography
        component="span"
        variant="body2"
        class="review-additional-services-summary__label"
      >
        {{ 'createShipment.reviewAndPay.additionalServices.signatureOnDelivery' | translate }}
      </puro-typography>
      <puro-typography component="span" variant="body2">
        {{ view().signatureI18nKey | translate }}
      </puro-typography>
    </div>
  </div>
</app-review-detail-card>
